import { useContext } from "react";

import { RootStoreContext } from "./RootStore";

export const useStores = () => {
  const stores = useContext(RootStoreContext);
  if (!stores) {
    throw Error("Store was not initialized");
  }
  return stores;
};
